import React, { useContext } from 'react'



// Context
import { CasLanguageState } from 'context/cas-format-context'

// Styles
import styles from './CASSyntax.module.scss'

interface Props {
  language: string
  children: React.ReactNode | React.ReactNode[]
}

const CASSyntax = ({ language, children }:Props) => {
  const state = useContext(CasLanguageState)
  

  return (
    <div className={`${state === language ? '' : styles.hide}`}>
      {children}
    </div>
  )
}

export default CASSyntax